/**
 * @generated SignedSource<<0e4ab8a6a01598887cef83888f095afe>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type BloodChemistry = "ALBUMIN" | "ALK_PHOSPHOTASE" | "AMYLASE" | "BILIRUBIN" | "BLOOD_SUGAR" | "CHLORIDE" | "CHOLSTEROL" | "CHOLSTEROL_HDL" | "CK" | "CREATININE" | "CRP" | "GAMMA_GT" | "GOT_ASAT" | "GPT_ALAT" | "HDL" | "LDH" | "NT_PRO_BNP" | "PHOSPHATE" | "POTASSIUM" | "SODIUM" | "TRIGLYCERIDE" | "TROPONIN_T" | "UREA" | "URIC_ACID";
export type Coagulation = "D_DIMER" | "INR" | "QUICK";
export type Hematology = "HAEMOGRAM_II" | "HAEMOGRAM_V" | "HBA1_C";
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type RapidTest = "COVID19" | "LACTOSE_INTOTERANCE" | "STREP_A";
export type UrineDiagnostic = "BETA_HCG" | "MICROALBUMIN" | "STIX_SEDIMENT" | "URICULT";
import { FragmentRefs } from "relay-runtime";
export type chMeasLaboratoryPrescriptionFragment$data = {
  readonly bloodChemistries: ReadonlyArray<BloodChemistry>;
  readonly coagulations: ReadonlyArray<Coagulation>;
  readonly concludedAt: string | null;
  readonly concludedBy: string | null;
  readonly createdAt: string;
  readonly createdBy: string;
  readonly fileId: string | null;
  readonly fileMetadata: {
    readonly documentType: string;
    readonly extension: string;
    readonly lengthInKilobytes: number;
  } | null;
  readonly hematologies: ReadonlyArray<Hematology>;
  readonly id: string;
  readonly language: Language;
  readonly patientId: string;
  readonly progressNoteId: string;
  readonly rapidTests: ReadonlyArray<RapidTest>;
  readonly sentAt: string | null;
  readonly sentBy: string | null;
  readonly signedAt: string | null;
  readonly signedBy: string | null;
  readonly updatedAt: string | null;
  readonly updatedBy: string | null;
  readonly urineDiagnostics: ReadonlyArray<UrineDiagnostic>;
  readonly " $fragmentType": "chMeasLaboratoryPrescriptionFragment";
};
export type chMeasLaboratoryPrescriptionFragment$key = {
  readonly " $data"?: chMeasLaboratoryPrescriptionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"chMeasLaboratoryPrescriptionFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "chMeasLaboratoryPrescriptionFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fileId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "language",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "patientId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "progressNoteId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "signedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "signedBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sentAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sentBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "concludedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "concludedBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DocumentFileMetadata",
      "kind": "LinkedField",
      "name": "fileMetadata",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "documentType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "extension",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lengthInKilobytes",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bloodChemistries",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "coagulations",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hematologies",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urineDiagnostics",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rapidTests",
      "storageKey": null
    }
  ],
  "type": "ch_MeasLaboratoryPrescription",
  "abstractKey": null
};

(node as any).hash = "b14cee624bc8ae8383583172c99b180d";

export default node;
